import { Preferences } from "@yodlee/common-components/dist/types/interfaces";
import { cloneDeep } from "lodash";

export const getUpdatedPreferences = (userPreferenceData: Preferences, CONTAINER_ID: string, FORM_ID: string, FIELD_ID: string, fieldValue: string): Preferences => {
    let newUserPreferenceData = cloneDeep(userPreferenceData);
    const serviceRequestListWidgetPreferences = newUserPreferenceData?.preferences?.widgets?.find(widget => widget.id === CONTAINER_ID);
    if (!serviceRequestListWidgetPreferences) {
        newUserPreferenceData = {
            preferences: {
                ...newUserPreferenceData?.preferences,
                widgets: [
                    ...(newUserPreferenceData?.preferences?.widgets || []),
                    {
                        id: CONTAINER_ID,
                        forms: [
                            {
                                id: FORM_ID,
                                fields: [
                                    {
                                        id: FIELD_ID,
                                        value: fieldValue
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        }
    }
    const filterFormPreferences = serviceRequestListWidgetPreferences?.forms?.find(form => form.id === FORM_ID);
    if (!filterFormPreferences && serviceRequestListWidgetPreferences) {
        serviceRequestListWidgetPreferences.forms = [
            ...(serviceRequestListWidgetPreferences?.forms || []),
            {
                id: FORM_ID,
                fields: [
                    {
                        id: FIELD_ID,
                        value: fieldValue
                    }
                ]
            }
        ]
    }
    const quickFilterFormValue = filterFormPreferences?.fields?.find(field => field.id === FIELD_ID);
    if (!quickFilterFormValue && filterFormPreferences) {
        filterFormPreferences.fields = [
            ...(filterFormPreferences?.fields || []),
            {
                id: FIELD_ID,
                value: fieldValue
            }
        ]
    }
    else if (quickFilterFormValue && filterFormPreferences) {
        quickFilterFormValue.value = fieldValue;
    }

    return newUserPreferenceData;
}